import { Controller } from '@hotwired/stimulus'

// One-shot ping when the customer actually loads the share page in a browser.
export default class extends Controller {
  static values = { url: String }

  connect() {
    if (!this.urlValue) return

    fetch(this.urlValue, { method: 'POST', credentials: 'same-origin' }).catch(() => {})
  }
}
